import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const { setUser } = useAuth();
  const processed = React.useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = loc.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login"); return; }
    const session_id = m[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        setUser(data);
        nav("/dashboard", { replace: true });
      } catch (e) {
        nav("/login?error=oauth", { replace: true });
      }
    })();
  }, [loc, nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-app">
      <div className="text-center">
        <div className="w-12 h-12 mx-auto rounded-full border-4 border-[var(--primary)] border-t-transparent spinner mb-4" />
        <div className="font-display text-lg">Conectando con Google...</div>
      </div>
    </div>
  );
}
